// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconChefHat = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M6 22h12v-8.416A5.001 5.001 0 0016 4a5 5 0 00-4-2 5 5 0 00-4 2 5 5 0 00-2 9.584zm8-10.764A3 3 0 1016 6h-.999l-.6-.799A3 3 0 0012 4c-.98 0-1.85.468-2.401 1.201l-.6.799h-1A3 3 0 1010 11.236v2.348A5 5 0 018 14v2h8v-2a5 5 0 01-2-.416zM16 18H8v2h8z"
    />
  );
export default SvgIconChefHat;
